import { ITableColumn } from '@components/common/UTable/UTable';

export const columns = (drugsTypes: any[]): ITableColumn[] => [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Препарат',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
  },
  {
    title: 'Вид препарата',
    dataIndex: 'drugTypeId',
    key: 'drugTypeId',
    sorterKey: 'drugType.name',
    sorter: true,
    type: 'select',
    payload: {
      options: drugsTypes,
      fieldNames: {
        label: 'name',
        value: 'id',
      },
    },
  },
];
